/**
 * Particle profiles per tap_fx cosmetic code.
 * Shared by Main (live taps) and Hub atelier cards/preview.
 */
export const TAP_FX_PROFILES = {
  default: { count: 4, dist: 18, spread: 36, rise: 0 },
  tap_fx_sparks: { count: 8, dist: 22, spread: 40, rise: 8 },
  tap_fx_ember: { count: 9, dist: 14, spread: 28, rise: 32 },
  tap_fx_ice: { count: 10, dist: 20, spread: 38, rise: 4 },
  tap_fx_nova: { count: 12, dist: 10, spread: 48, rise: 0 },
  tap_fx_dust: { count: 11, dist: 12, spread: 22, rise: -14 },
  tap_fx_shards: { count: 9, dist: 28, spread: 50, rise: 6 },
  tap_fx_plasma: { count: 8, dist: 34, spread: 56, rise: 18 },
  tap_fx_supernova: { count: 16, dist: 20, spread: 64, rise: 0 },
  tap_fx_meteor: { count: 6, dist: 42, spread: 28, rise: -8 },
  tap_fx_shockwave: { count: 5, dist: 8, spread: 56, rise: 0 },
};

/** Spawn one burst of tap sparks into `stage` (positioned element). */
export function spawnTapFxBurst(stage, code, { scale = 1 } = {}) {
  if (!stage) return;
  const profile = TAP_FX_PROFILES[code] || TAP_FX_PROFILES.default;
  const w = stage.clientWidth || 64;
  const h = stage.clientHeight || 64;
  // Same as live taps: originate near the touch point (centre with jitter).
  const cx = w * (0.35 + Math.random() * 0.3);
  const cy = h * (0.35 + Math.random() * 0.3);
  const count = profile.count;
  // One fragment and one timer for the whole burst — inserting particles one by
  // one, each with its own removal timer, is up to 16 separate DOM mutations and
  // 16 timers per burst.
  const frag = document.createDocumentFragment();
  const batch = [];
  for (let i = 0; i < count; i += 1) {
    const spark = document.createElement('i');
    spark.className = `tap-spark fx-${code}`;
    const angle = (Math.PI * 2 * i) / count + Math.random() * 0.35;
    const dist = (profile.dist + Math.random() * profile.spread) * scale;
    const rot0 = Math.random() * 360;
    const rot1 = rot0 + (90 + Math.random() * 220) * (Math.random() < 0.5 ? 1 : -1);
    spark.style.left = `${cx}px`;
    spark.style.top = `${cy}px`;
    spark.style.setProperty('--sx', `${Math.cos(angle) * dist}px`);
    spark.style.setProperty('--sy', `${Math.sin(angle) * dist - profile.rise * scale}px`);
    spark.style.setProperty('--rot', `${rot0.toFixed(1)}deg`);
    spark.style.setProperty('--rot-end', `${rot1.toFixed(1)}deg`);
    spark.style.animationDelay = `${i * 14}ms`;
    frag.appendChild(spark);
    batch.push(spark);
  }
  stage.appendChild(frag);
  window.setTimeout(() => batch.forEach((spark) => spark.remove()), 720);
}
